import type { CardCoversRestApiResponse } from '@atlassian/jira-software-board-uif-types';
import type { IssueMediaCollection } from '../../model/issue/issue-media-types';

export const transformCardCoversRestApiResponse = (
	cardCoversResponse: CardCoversRestApiResponse,
): IssueMediaCollection =>
	Object.entries(cardCoversResponse.cardMedia).reduce(
		(map, [issueId, cardMediaForIssueId]): IssueMediaCollection =>
			Object.assign<IssueMediaCollection, IssueMediaCollection>(map, {
				[String(issueId)]: {
					attachmentId: String(cardMediaForIssueId.attachmentId),
					attachmentMediaApiId: cardMediaForIssueId.mediaApiFileId,
					endpointUrl: cardCoversResponse.media.endpointUrl,
					clientId: cardCoversResponse.media.clientId,
					isHiddenByUser: false,
					token: cardMediaForIssueId.mediaReadToken,
				},
			}),
		{},
	);
